<div
  class="segmented-tabs"
  [ngClass]="['segmented-tabs--' + variant, 'segmented-tabs--' + size]"
  role="tablist"
>
  <button
    *ngFor="let opt of options; trackBy: trackByValue"
    [ngClass]="opt.pendoClass"
    type="button"
    role="tab"
    class="segmented-tabs__tab"
    [attr.id]="tabId(opt.value)"
    [class.segmented-tabs__tab--active]="value === opt.value"
    [class.segmented-tabs__tab--icon]="!!opt.icon"
    [attr.aria-selected]="value === opt.value"
    [attr.aria-label]="opt.icon ? opt.label : null"
    [matTooltip]="opt.tooltip || ''"
    matTooltipPosition="below"
    (click)="onSelect(opt.value)"
  >
    <mat-icon *ngIf="opt.icon">{{ opt.icon }}</mat-icon>
    <ng-container *ngIf="!opt.icon">{{ opt.label }}</ng-container>
  </button>
</div>
